import { UserData } from '@e3dc-react/shell/Types'
import { Installation } from 'src/Libs/installations/models/installation.model'
import { InstallationExtensionsModel } from '../models/installation-extensions.model'
import { ExtensionStates, ExtensionTypes } from '../types'
import { hasAccessToDirectMarketing } from './has-access-to-direct-marketing'

interface ShouldShowDirectMarketingBannerParams {
  installation?: Installation
  userData?: UserData
  installationExtensionsState: InstallationExtensionsModel[]
}

export const shouldShowDirectMarketingBanner = ({
  installation,
  userData,
  installationExtensionsState,
}: ShouldShowDirectMarketingBannerParams): boolean => {
  const sessionStorageExtensionBanner = sessionStorage.getItem('extensionBanner')
  const isDismissed = sessionStorageExtensionBanner === 'false'

  const hasActiveDirectMarketing = installationExtensionsState.some(
    extension => extension.extension === ExtensionTypes.LuoxOne && extension.state === ExtensionStates.Active
  )

  return hasAccessToDirectMarketing(installation, userData) && !isDismissed && !hasActiveDirectMarketing
}
